module.exports = __webpack_public_path__ + "img/abilities.56cb8767.svg";